<template>
  <article id="notification-modal" class="modal">
    <a class="force-close modal-close btn-floating btn-small white">
      <i class="fas fa-times-circle white grey-text a"/>
    </a>
    <div class="modal-content">
      <div class="row">
        <div class="col s12">
          <span v-html="message" />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'NotificationModal',
  props: ['message'],
  data() {
    return {
      modal: null,
    };
  },
  methods: {
    initModal() {
      return this.materialize.Modal.init(document.getElementById('notification-modal'), {
        preventScrolling: false,
      });
    },
  },
  mounted() {
    this.modal = this.initModal();
  },
};
</script>
